<div *ngIf="loading || (loading && (!items || items.length <= 0))" class="progress mt-10">
  <div
    class="progress-bar progress-bar-striped progress-bar-animated bg-primary"
    role="progressbar"
    aria-valuenow="75"
    aria-valuemin="0"
    aria-valuemax="100"
    style="width: 75%"
  ></div>
</div>
<div class="filter-list">
  <div class="filter-list-wrapper">
    <ng-container *ngTemplateOutlet="!!topFilter ? TopFilter : SideFilter"></ng-container>
  </div>
</div>

<div (click)="toggleFilters()" [ngClass]="shouldDisplayOverlay ? 'overlay-visible' : 'overlay-hidden'"></div>

<ng-template #TopFilter>
  <div class="row filter-list-background" [hidden]="loading || (loading && (!items || items.length <= 0))">
    <div class="col-12">
      <div class="row search-container">
        <div class="col-12 col-md" *ngIf="!searchDisabled">
          <div class="row">
            <ng-template name="searchFields" libCustomHost></ng-template>
          </div>
        </div>
        <div class="col col-md-2" *ngIf="batchSizes && batchSizes.length > 1">
          <lib-filter-list-batch (batchSizeUpdated)="setBatchSize($event)" [batchSizes]="batchSizes">
          </lib-filter-list-batch>
        </div>
        <div class="col-auto" *ngIf="layouts && layouts.length > 1">
          <button
            class="btn btn-light layout-btn"
            [ngClass]="{ active: layoutIndex === currentLayoutIdx }"
            *ngFor="let layout of layouts; let layoutIndex = index"
            (click)="changeLayout(layoutIndex)"
          >
            <i [ngClass]="layout.getIconClass()"></i>
          </button>
        </div>
      </div>
    </div>

    <div #gungFilters *ngIf="!isSmallScreen" [ngClass]="getGungFilterClasses()" class="sticky">
      <div class="gung-filters d-flex flex-column flex-wrap">
        <div class="d-flex flex-wrap bg-white-custom w-100">
          <div
            #gungFilters
            *ngFor="let renderFilter of renderFilters"
            [ngClass]="getGungFilterClasses()"
            class="mb-1 filter-option"
          >
            <lib-filter-list-top-filter
              [class]="renderFilter.customClass"
              [renderFilter]="renderFilter"
              (selectValue)="setSelection(renderFilter.id, $event, true)"
              (deselectValue)="setSelection(renderFilter.id, $event, false)"
              (selectValueRange)="setMultipleSelection(renderFilter.id, true, $event)"
            ></lib-filter-list-top-filter>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="m-0 mt-2 text-results-top-filters">
          <span
            style="padding-top: 1px"
            class="mt-1 mr-3"
            *ngIf="limit > 0 && renderItems && items && totalItemsNumber && items.length === totalItemsNumber"
          >
            {{ 'PRODUCT_LIST_TOTAL' | translate: { render: (renderItems | async).length, total: totalItemsNumber } }}
          </span>
          <span
            style="padding-top: 1px"
            class="mt-1 mr-3"
            *ngIf="limit > 0 && renderItems && items && totalItemsNumber && totalItemsNumber !== items.length"
          >
            {{
              'PRODUCT_LIST_FILTER_TOTAL'
                | translate
                  : { render: (renderItems | async).length, filter: totalItemsNumber, total: totalItemsNumber }
            }}
          </span>
          <lib-selected-filter
            [topFilter]="true"
            [renderFilters]="renderFiltersForSelected"
            (deselectAll)="clearSelection()"
            (deselectValue)="setSelection($event.filterId, $event.valueId, false)"
            (deselectValueRange)="setMultipleSelection($event.filterId, false, $event.valueIdRange)"
          >
          </lib-selected-filter>
        </div>
      </div>
    </div>
    <div *ngIf="isSmallScreen" class="col-12">
      <div class="m-0 mt-2 text-results-top-filters">
        <span
          style="padding-top: 1px"
          class="mt-1 mr-3"
          *ngIf="limit > 0 && renderItems && items && totalItemsNumber && items.length === totalItemsNumber"
        >
          {{ 'PRODUCT_LIST_TOTAL' | translate: { render: (renderItems | async).length, total: totalItemsNumber } }}
        </span>
        <span
          style="padding-top: 1px"
          class="mt-1 mr-3"
          *ngIf="limit > 0 && renderItems && items && totalItemsNumber && totalItemsNumber !== items.length"
        >
          {{
            'PRODUCT_LIST_FILTER_TOTAL'
              | translate
                : { render: (renderItems | async).length, filter: totalItemsNumber, total: totalItemsNumber }
          }}
        </span>
        <lib-selected-filter
          [topFilter]="true"
          [renderFilters]="renderFiltersForSelected"
          (deselectAll)="clearSelection()"
          (deselectValue)="setSelection($event.filterId, $event.valueId, false)"
          (deselectValueRange)="setMultipleSelection($event.filterId, false, $event.valueIdRange)"
        >
        </lib-selected-filter>
      </div>
    </div>
    <div #gungFilters *ngIf="isSmallScreen" [ngClass]="getGungFilterClasses()" class="col-12 gung-filters filter-drawer d-flex flex-column flex-wrap">
      <div class="filter-header filter-drawer-header px-3 py-3" [hidden]="!renderFilters || renderFilters.length == 0">
        <i class="fas fa-sliders-h pr-2"></i>
        <span class="font-weight-bold" translate>FILTERS</span>
        <button type="button" class="btn filter-drawer-close" (click)="toggleFilters()" [attr.aria-label]="'CLOSE' | translate">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="d-flex flex-column">
        <lib-filter-list-top-filter
          *ngFor="let renderFilter of renderFilters"
          [renderFilter]="renderFilter"
          (selectValue)="setSelection(renderFilter.id, $event, true)"
          (deselectValue)="setSelection(renderFilter.id, $event, false)"
          (selectValueRange)="setMultipleSelection(renderFilter.id, true, $event)"
        ></lib-filter-list-top-filter>
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col-12 position-relative">
          <div *ngIf="loadingItemsState" class="loading-items-state">
            <div class="spinner-grow" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <ng-template libCustomHost></ng-template>
          <p *ngIf="items && items.length === 0" class="nothing-found">
            <span [innerHTML]="getNothingFoundTranslateTag() | translate"></span>
          </p>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="loadMoreItems"></ng-container>
    </div>
    <div *ngIf="items && items.length > 0 && renderFilters && renderFilters.length > 0">
      <a [ngClass]="{ 'hide-filter-toggle': getGungFilterClasses().open }" class="gung-filters-toggle" (click)="toggleFilters()">
        <i class="fa fa-filter"></i>
      </a>

      <a [ngClass]="{ 'hide-filter-toggle': !getGungFilterClasses().open }" class="gung-filters-toggle close-filters has-drawer-close" (click)="toggleFilters()">
        <i class="fa fa-times"></i>
      </a>
    </div>
  </div>
</ng-template>

<ng-template #SideFilter>
  <div class="row filter-list-background" [hidden]="loading || (loading && (!items || items.length <= 0))">
    <div
      #gungFilters
      [ngClass]="getGungFilterClasses()"
      class="col-12 sticky gung-filters filter-drawer d-flex flex-column"
    >
      <div class="row" *ngIf="searchAboveFilters">
        <div class="mb-2 col-md col-12" *ngIf="!searchDisabled">
          <div class="row">
            <ng-template name="searchFields" libCustomHost></ng-template>
          </div>
        </div>
      </div>
      <div class="gung-filters-inner d-flex flex-column p-0">
        <div class="filter-header filter-drawer-header px-4 py-3" [hidden]="!renderFilters || renderFilters.length == 0">
          <i class="fas fa-sliders-h pr-2"></i>
          <span class="font-weight-bold" translate>FILTERS</span>
          <button type="button" class="btn filter-drawer-close" (click)="toggleFilters()" [attr.aria-label]="'CLOSE' | translate">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <ng-container *ngTemplateOutlet="selectedFilterTop ? selectedFilters : filterOptions"></ng-container>
        <ng-container *ngTemplateOutlet="!selectedFilterTop ? selectedFilters : filterOptions"></ng-container>
        <ng-template #filterOptions>
          <lib-filter-list-side-filter
            *ngFor="let renderFilter of renderFilters"
            [renderFilter]="renderFilter"
            (selectValue)="setSelection(renderFilter.id, $event, true)"
            (deselectValue)="setSelection(renderFilter.id, $event, false)"
            (selectValueRange)="setMultipleSelection(renderFilter.id, true, $event)"
          ></lib-filter-list-side-filter>
        </ng-template>
        <ng-template #selectedFilters>
          <lib-selected-filter
            [topFilter]="true"
            [renderFilters]="renderFiltersForSelected"
            (deselectAll)="clearSelection()"
            (deselectValue)="setSelection($event.filterId, $event.valueId, false)"
            (deselectValueRange)="setMultipleSelection($event.filterId, false, $event.valueIdRange)"
            [topFilter]="false"
            [showFilterTitle]="showFilterTitle"
          >
          </lib-selected-filter>
        </ng-template>
      </div>
    </div>
    <div class="gung-products" [ngClass]="renderFilters && renderFilters.length > 0 ? 'col-12 col-lg-9' : 'col-12'">
      <div class="product-list-search-group pt-2">
        <div class="row">
          <div class="mb-2 col-md col-12" *ngIf="!searchAboveFilters && !searchDisabled">
            <div class="row">
              <ng-template name="searchFields" libCustomHost></ng-template>
            </div>
          </div>
          <div class="col col-md-3" *ngIf="batchSizes && batchSizes.length > 1">
            <lib-filter-list-batch (batchSizeUpdated)="setBatchSize($event)" [batchSizes]="batchSizes">
            </lib-filter-list-batch>
          </div>
          <div class="col-auto" *ngIf="layouts && layouts.length > 1">
            <button
              class="btn btn-light layout-btn"
              [ngClass]="{ active: layoutIndex === currentLayoutIdx }"
              *ngFor="let layout of layouts; let layoutIndex = index"
              (click)="changeLayout(layoutIndex)"
            >
              <i [ngClass]="layout.getIconClass()"></i>
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col-12 position-relative">
            <div *ngIf="loadingItemsState" class="loading-items-state">
              <div class="spinner-grow" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <ng-template libCustomHost></ng-template>
            <p *ngIf="items && items.length === 0" class="nothing-found">
              <span [innerHTML]="getNothingFoundTranslateTag() | translate"></span>
            </p>
          </div>
        </div>
        <ng-container *ngTemplateOutlet="loadMoreItems"></ng-container>
      </div>
    </div>
    <div *ngIf="items && items.length > 0 && renderFilters && renderFilters.length > 0">
      <a [ngClass]="{ 'hide-filter-toggle': getGungFilterClasses().open }" class="gung-filters-toggle" (click)="toggleFilters()">
        <i class="fa fa-filter"></i>
      </a>

      <a [ngClass]="{ 'hide-filter-toggle': !getGungFilterClasses().open }" class="gung-filters-toggle close-filters has-drawer-close" (click)="toggleFilters()">
        <i class="fa fa-times"></i>
      </a>
    </div>
  </div>
</ng-template>


<ng-template #loadMoreItems>
  <div *ngIf="!paginationList" class="d-flex justify-content-center align-items-center btn-load-more">
    <button
      *ngIf="!!items && items.length > 0 && !!totalItemsNumber && totalItemsNumber > items.length"
      class="btn btn-primary btn-block"
      (click)="loadMore()"
      style="overflow-anchor: none"
    >
      <span translate [translateParams]="{ limit: items.length, total: totalItemsNumber, batchSize: batchSize }"
        >GUNG_ITEM_LIST_LOAD_MORE</span
      >
    </button>
  </div>
  <div *ngIf="!!paginationList" class="d-flex justify-content-center align-items-center btn-load-more">
    <nav *ngIf="!!items && totalItemsNumber > batchSize" aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item">
          <button
            class="page-link"
            [disabled]="pagination.currentPage === 1"
            (click)="loadPage(pagination.currentPage - 1)"
            translate
          >
            PREVIOUS
          </button>
        </li>
        <li *ngIf="pagination.currentPage >= 4" class="page-item">
          <button class="page-link" (click)="loadPage(1)">{{ 1 }}</button>
        </li>
        <li *ngIf="pagination.currentPage >= 5" class="page-item align-self-end">...</li>
        <li *ngIf="pagination.currentPage - 2 > 0" class="page-item">
          <button class="page-link" (click)="loadPage(pagination.currentPage - 2)">
            {{ pagination.currentPage - 2 }}
          </button>
        </li>
        <li *ngIf="pagination.currentPage - 1 > 0" class="page-item">
          <button class="page-link" (click)="loadPage(pagination.currentPage - 1)">
            {{ pagination.currentPage - 1 }}
          </button>
        </li>
        <li class="page-item active">
          <span class="page-link">{{ pagination.currentPage }}</span>
        </li>
        <li *ngIf="pagination.currentPage + 1 <= pagination.totalPages" class="page-item">
          <button class="page-link" (click)="loadPage(pagination.currentPage + 1)">
            {{ pagination.currentPage + 1 }}
          </button>
        </li>
        <li *ngIf="pagination.currentPage + 2 <= pagination.totalPages" class="page-item">
          <button class="page-link" (click)="loadPage(pagination.currentPage + 2)">
            {{ pagination.currentPage + 2 }}
          </button>
        </li>
        <li *ngIf="pagination.currentPage <= pagination.totalPages - 4" class="page-item align-self-end">...</li>
        <li *ngIf="pagination.currentPage <= pagination.totalPages - 3" class="page-item">
          <button class="page-link" (click)="loadPage(pagination.totalPages)">{{ pagination.totalPages }}</button>
        </li>
        <li class="page-item">
          <button
            class="page-link"
            [disabled]="pagination.currentPage === pagination.totalPages"
            (click)="loadPage(pagination.currentPage + 1)"
            translate
          >
            NEXT
          </button>
        </li>
      </ul>
    </nav>
  </div>
</ng-template>
